/**
 * 将一些功能进行封装, 可作为模块进行引入
 * 变量使用小驼峰命名, 方法使用大驼峰命名
 * 模块分为项目通用和项目专用
 */

import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import cookie from 'react-cookies';
import * as ReactDOM from 'react-dom/client';
import { PlusOutlined } from '@ant-design/icons';
import { green, red, yellow, blue, grey } from '@ant-design/colors';
import OSS from 'ali-oss';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';

import {
    ConfigProvider,
    Space,
    Button,
    Dropdown,
    message,
} from 'antd';
import {
    DownOutlined,
    EditOutlined,
    DeleteOutlined,
    LockOutlined,
    UnlockOutlined,
    StockOutlined,
    AuditOutlined,
    FileProtectOutlined,
    FundOutlined,
    PayCircleOutlined,
    FileTextOutlined,
    RotateRightOutlined,
    BarChartOutlined,
} from '@ant-design/icons';

// 导出页面为PDF格式
import html2canvas from 'html2canvas';
import JSPDF from 'jspdf';

import CNF from './Config';

import IPModal from '../components/IPModal';

import DefaultImagePng from '../images/default-image.png';

/*
 ************************************************
 ** 通用部分 **
 ************************************************
 */

/**
 * 国际化语言
 */
export const locale = CNF.locale === 'zhCN' ? zhCN : enUS;

/***
 * 浏览器宽度
 */
export const winWidth = getWinWidth();
function getWinWidth() {
    var winWidth = 0;
    // 获取窗口宽度
    if (window.innerWidth) {
        winWidth = window.innerWidth;
    } else if ((document.body) && (document.body.clientWidth)) {
        winWidth = document.body.clientWidth;
    }
    return winWidth;
}

/***
 * 浏览器高度
 */
export const winHeight = getWinHeight();
function getWinHeight() {
    var winHeight = 0;
    //  获取窗口高度
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }
    return winHeight;
}

export const uuid = generateUUID()
function generateUUID() {
    return uuidv4();
}

/**
 * 是否大于配置文件设定的屏幕宽度
 * 用于使用字段显示宽度
 */
export const isGTscreenWidth = winWidth > CNF.screenWidth ? true : false;

/**
 * 判断是否为移动设备
 */
export const isMobileDevice = IsMobile();
function IsMobile() {
    var ios = /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    var mobile = ios || /Android|webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(navigator.userAgent);
    return mobile;
}

/**
 * 必填项标志（Required field flag）用rff简写
 */
export const rff = <span style={{ color: 'red' }}>*</span>;

/**
 * 默认图片数据
 */
export const defaultImage = DefaultImagePng

/**
 * 主要用于通用弹框
 */
export const rootReactDom = ReactDOM.createRoot(document.createElement('div'));

/**
 * 当前日期
 */
export const currentDate = CurrentDate();

/**
 * 添加请求头
 * @param {*} ct 
 * @returns 
 */
export function AddRequestHeaders(ct = 'application/json') {
    let headers = {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + cookie.load(CNF.cookies.keyToken),
    }
    if (ct) {
        headers['Content-Type'] = ct;
    }
    return headers;
}

/**
 * 删除cookie, 并重定向到登录界面
 */
export function DeleteCookies() {
    cookie.remove(CNF.cookies.keyId,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyUid,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyDisplayname,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyToken,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyAvatarUrl,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyThemeColor,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyIsDisplayTableBorder,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    window.location.href = CNF.loginUrl;
}

/**
 * 上传图片按钮
 */
export const uploadImageButton = (
    <button
        style={{
            border: 0,
            background: 'none',
            cursor: 'pointer',
        }}
        type='button'
    >
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>上传图片</div>
    </button>
);

/**
 * 上传图像按钮
 */
export const uploadAvatarButton = (
    <button
        style={{
            border: 0,
            background: 'none',
            cursor: 'pointer',

        }}
        type="button"
    >
        <PlusOutlined />
        <div style={{ marginTop: 8, }}>上传图像</div>
    </button>
);

/**
 * 将图片转换成base64格式
 * @param {*} img 
 * @param {*} callback 
 */
export function GetBase64(img, callback) {
    // 创建一个FileReader对象用于读取图片数据
    const reader = new FileReader();

    // 当读取完成时触发load事件，调用回调函数并传入读取的结果
    reader.addEventListener('load', () => callback(reader.result));

    // 开始读取图片数据，将其转换为DataURL格式
    reader.readAsDataURL(img);
}

/**
 * 连接资源参数
 * @param {*} obj 
 * @returns 
 */
export function UjoinParams(obj) {
    var params = '?'
    for (var key in obj) {
        params += key + '=' + obj[key] + '&'
    }
    return params.slice(0, - 1);
}

/***
 * elementName: 需要输出PDF的页面id
 * htmlTitle: 页面标题
 * currentTime: 创建时间
 */
export function Html2pdf(elementName, htmlTitle, currentTime, hasImage = false) {
    const a4w = 190;    //  A4大小，210mm x 297mm，四边各保留20mm的边距
    const a4h = 237;
    var element = document.getElementById(elementName);
    var tableDom = document.getElementById('table-id');
    var tableHeight = a4h;
    if (tableDom) {
        tableHeight = tableDom.getBoundingClientRect().height / 3.78;   //  转换成mm
    }
    var emptyDiv = null;
    //  判断table的高度是否小于a4h，如果小于a4h，则插入一个div填充table，使其刚好等于a4h
    if (tableHeight < a4h && hasImage) {
        emptyDiv = document.createElement('div');
        emptyDiv.style.width = '100%';
        emptyDiv.style.height = `${a4h - tableHeight + 20}mm`;
        tableDom.insertAdjacentElement('afterend', emptyDiv);
    }
    html2canvas(element, {
        logging: false,
        useCORS: true,
        scale: 2,
    }).then(function (canvas) {
        var pdf = new JSPDF('p', 'mm', 'a4'); // A4纸，纵向
        var ctx = canvas.getContext('2d');
        var imgHeight = Math.floor(a4h * canvas.width / a4w); // 按A4显示比例换算一页图像的像素高度

        var renderedHeight = 0;
        while (renderedHeight < canvas.height) {
            var page = document.createElement('canvas');
            page.width = canvas.width;
            page.height = Math.min(imgHeight, canvas.height - renderedHeight); // 可能内容不足一页

            // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
            page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
            pdf.addImage(page.toDataURL('image/jpeg', 3.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距

            renderedHeight += imgHeight
            if (renderedHeight < canvas.height) {
                pdf.addPage(); // 如果后面还有内容，添加一个空页
            }
        }
        pdf.save(htmlTitle + currentTime + '.pdf');
        if (emptyDiv) {
            emptyDiv.remove();  //  删除空白节点
        }
    })
}

/**
 * 获取上一月
 * YYYY-MM
 * @returns 
 */
export function LastMonth() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth();
    if (month < 1) {
        month = 12;
        year -= 1;
    }
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    var lastMonth = year + '-' + month;
    return lastMonth;
}

/**
 * 获取当前时间
 * YYYY-MM-dd HH:mm:ss
 * @returns 
 */
export function CurrentTime() {
    var date = new Date();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var strHours = date.getHours();
    var strtMinutes = date.getMinutes();
    var strtSeconds = date.getSeconds();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    if (strHours >= 0 && strHours <= 9) {
        strHours = '0' + strHours;
    }
    if (strtMinutes >= 0 && strtMinutes <= 9) {
        strtMinutes = '0' + strtMinutes;
    }
    if (strtSeconds >= 0 && strtSeconds <= 9) {
        strtSeconds = '0' + strtSeconds;
    }
    var currentTime = date.getFullYear() + '-' + month + '-' + strDate + ' ' + strHours + ':' + strtMinutes + ':' + strtSeconds;
    return currentTime;
}

/**
 * 获取当前日期
 * YYYY-MM-dd
 * @returns 
 */
export function CurrentDate() {
    var date = new Date();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    var currentDate = date.getFullYear() + '-' + month + '-' + strDate;
    return currentDate;
}

/**
 * 显示提示框信息信息
 * @param {*} key 
 * @param {*} title 
 * @param {*} action 
 * @param {*} modulename 
 * @param {*} isRefresh 
 * @param {*} uri 
 */
export const ShowIPModal = (key, title, action, modulename, isRefresh, uri, getPolicys = null) => {
    rootReactDom.render(
        <IPModal
            open={true}
            isRefresh={isRefresh}
            action={action}
            key={key}
            modulename={modulename}
            uri={uri}
            getPolicys={getPolicys}
            title={title}
        />
    );
}

/**
 * 日期格式化
 * @param {*} fmt 
 * @param {*} date 
 * @returns 
 */
export function DateFormat(fmt, date) {
    let ret;
    const opt = {
        'Y+': date.getFullYear().toString(),        // 年
        'm+': (date.getMonth() + 1).toString(),     // 月
        'd+': date.getDate().toString(),            // 日
        'H+': date.getHours().toString(),           // 时
        'M+': date.getMinutes().toString(),         // 分
        'S+': date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        };
    };
    return fmt;
}

/**
 * 获取按钮操作名称
 * @param {*} btnLists 权限列表
 * @param {*} modulename_ptn 模块权限
 * @param {*} record 当前行数据
 * @param {*} operation 操作
 * @returns 
 */
export function GetButtonActionName(btnLists, modulename_ptn, record, operation) {
    // 模块权限列表
    let mBtnLists = typeof btnLists === 'string' ? btnLists.split('|').filter(item => item.startsWith(modulename_ptn)) : [];
    return <Space size={CNF.searchMarginLeft}>
        {/* 里程 */}
        {mBtnLists.indexOf('btn_plms_car_update') > 0 ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation('里程', record) }}>里程</Button> : ''}
        {/* 回访 */}
        {mBtnLists.indexOf(modulename_ptn + '_visit') > 0 ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.VISIT, record) }}>{CNF.actionName.VISIT}</Button> : ''}
        {/* 进度 */}
        {mBtnLists.indexOf(modulename_ptn + '_progress') > 0 ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.PROGRESS, record) }}>{CNF.actionName.PROGRESS}</Button> : ''}
        {/* 修改 */}
        {mBtnLists.indexOf(modulename_ptn + '_update') > 0 ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.UPDATE, record) }}>{CNF.actionName.UPDATE}</Button> : ''}
        {/* 月报 */}
        {mBtnLists.indexOf(modulename_ptn + '_wo_mr') > 0 ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation('月报', record) }}>月报</Button> : ''}
        {/* 审核 */}
        {mBtnLists.indexOf(modulename_ptn + '_audit') > 0 ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.AUDIT, record) }}>{CNF.actionName.AUDIT}</Button> : ''}
        {/* 送审, 审定后不能送审 */}
        {mBtnLists.indexOf(modulename_ptn + '_toaudit') > 0 && record.audit_date === '' ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.TOAUDIT, record) }}>{CNF.actionName.TOAUDIT}</Button> : ''}
        {/* 审定, 已送审才能审定 */}
        {mBtnLists.indexOf(modulename_ptn + '_audited') > 0 ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.AUDITED, record) }}>{CNF.actionName.AUDITED}</Button> : ''}
        {/* 回款 */}
        {mBtnLists.indexOf(modulename_ptn + '_repayment') > 0 ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.REPAYMENT, record) }}>{CNF.actionName.REPAYMENT}</Button> : ''}
        {/* 档案 */}
        {mBtnLists.indexOf(modulename_ptn + '_archive') > 0 ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.ARCHIVE, record) }}>{CNF.actionName.ARCHIVE}</Button> : ''}
        {/* 禁用 */}
        {mBtnLists.indexOf(modulename_ptn + '_disable') > 0 &&
            record.status.toString() === CNF.status[0].value.toString() ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.DISABLE, record) }}>{CNF.actionName.DISABLE}</Button> : ''}
        {/* 激活 */}
        {mBtnLists.indexOf(modulename_ptn + '_active') > 0 &&
            record.status.toString() === CNF.status[1].value.toString() ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.ACTIVE, record) }}>{CNF.actionName.ACTIVE}</Button> : ''}
        {/* 删除 */}
        {mBtnLists.indexOf(modulename_ptn + '_delete') > 0 ? <Button size='small' color='primary' variant='solid' onClick={() => { operation(CNF.actionName.DELETE, record) }}>{CNF.actionName.DELETE}</Button> : ''}
    </Space>
}

/**
 * 获取基础操作名称
 * @param {*} btnLists 权限列表
 * @param {*} modulename_ptn 模块权限
 * @param {*} record 当前行数据
 * @param {*} operation 操作
 * @returns 
 */
export function GetDropdownActionName(btnLists, modulename_ptn, record, operation) {
    // 模块权限列表
    let mBtnLists = typeof btnLists === 'string' ? btnLists.split('|').filter(item => item.startsWith(modulename_ptn)) : [];
    let items = [];
    // 里程
    if (mBtnLists.indexOf('btn_plms_car_update') > 0) {
        items.push({ key: '1', label: (<Button icon={<StockOutlined />} color='primary' variant='link' onClick={() => { operation('里程', record) }}>里程</Button>) })
    }
    // 修改
    if (mBtnLists.indexOf(modulename_ptn + '_update') > 0) {
        // 审核后不可修改
        if (!(modulename_ptn === CNF.navItems[1].submenu[2].ptn && record.status !== CNF.offerStatus[0].value)) {
            items.push({ key: '2', label: (<Button icon={<EditOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.UPDATE, record) }}>{CNF.actionName.UPDATE}</Button>) })
        }
    }
    // 月报(工单)
    if (mBtnLists.indexOf(modulename_ptn + '_wo_mr') > 0) {
        items.push({ key: '3', label: (<Button icon={<BarChartOutlined />} color='primary' variant='link' onClick={() => { operation('月报', record) }}>月报</Button>) })
    }
    // 回访
    if (mBtnLists.indexOf(modulename_ptn + '_visit') > 0) {
        items.push({ key: '4', label: (<Button icon={<RotateRightOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.VISIT, record) }}>{CNF.actionName.VISIT}</Button>) })
    }
    // 进度
    if (mBtnLists.indexOf(modulename_ptn + '_progress') > 0) {
        items.push({ key: '5', label: (<Button icon={<FundOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.PROGRESS, record) }}>{CNF.actionName.PROGRESS}</Button>) })
    }
    // 审核
    if (mBtnLists.indexOf(modulename_ptn + '_audit') > 0) {
        // 审核后不可审核
        if (!(modulename_ptn === CNF.navItems[1].submenu[2].ptn && record.status !== CNF.offerStatus[0].value)) {
            items.push({ key: '6', label: (<Button icon={<AuditOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.AUDIT, record) }}>{CNF.actionName.AUDIT}</Button>) })
        }
    }
    // 送审, 审定后不能送审
    if (mBtnLists.indexOf(modulename_ptn + '_toaudit') > 0 && record.audit_amount <= 0) {
        items.push({ key: '7', label: (<Button icon={<AuditOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.TOAUDIT, record) }}>{CNF.actionName.TOAUDIT}</Button>) })
    }
    // 审定, 已送审才能审定
    if (mBtnLists.indexOf(modulename_ptn + '_audited') > 0 && record.audit_amount > 0) {
        items.push({ key: '8', label: (<Button icon={<FileProtectOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.AUDITED, record) }}>{CNF.actionName.AUDITED}</Button>) })
    }
    // 回款
    if (mBtnLists.indexOf(modulename_ptn + '_repayment') > 0) {
        items.push({ key: '9', label: (<Button icon={<PayCircleOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.REPAYMENT, record) }}>{CNF.actionName.REPAYMENT}</Button>) })
    }
    // 档案
    if (mBtnLists.indexOf(modulename_ptn + '_archive') > 0) {
        items.push({ key: '10', label: (<Button icon={<FileTextOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.ARCHIVE, record) }}>{CNF.actionName.ARCHIVE}</Button>) })
    }
    // 禁用
    if (mBtnLists.indexOf(modulename_ptn + '_disable') >= 0 &&
        record.status.toString() === CNF.status[0].value.toString()) {
        items.push({ key: '11', label: (<Button icon={<LockOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.DISABLE, record) }}>{CNF.actionName.DISABLE}</Button>) })
    }
    // 激活
    if (mBtnLists.indexOf(modulename_ptn + '_active') >= 0 &&
        record.status.toString() === CNF.status[1].value.toString()) {
        items.push({ key: '12', label: (<Button icon={<UnlockOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.ACTIVE, record) }}>{CNF.actionName.ACTIVE}</Button>) })
    }
    // 删除
    if (mBtnLists.indexOf(modulename_ptn + '_delete') >= 0) {
        items.push({ key: '13', label: (<Button icon={<DeleteOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.DELETE, record) }}>{CNF.actionName.DELETE}</Button>) })
    }
    return <ConfigProvider
        theme={{
            components: {
                Dropdown: {
                    paddingBlock: 0,
                },
                Button: {
                    paddingInline: 0,
                }
            },
        }}
    >
        <Dropdown menu={{ items, }}>
            <Button color='primary' variant='link' style={{ padding: 0, height: 10, margin: 0 }}>
                操作
                <DownOutlined />
            </Button>
        </Dropdown>
    </ConfigProvider>
}


/**
 * 将指定的文本值复制到剪贴板。
 * @param {string} value 需要被复制的文本。
 * 
 * 函数首先判断当前浏览器是否支持navigator.clipboard.writeText方法来直接复制文本到剪贴板。
 * 如果支持且当前环境是安全上下文（https协议或localhost），则使用现代的剪贴板API进行复制。
 * 如果不支持或环境不安全，则回退到传统的方法: 创建一个textarea元素，将文本填入，选中文本后使用document.execCommand('copy')进行复制。
 * 不论采用哪种方式，复制成功或失败后都会给出相应的用户反馈。
 */
export function CopyToClipboard(value) {
    // 兼容性判断，选择合适的复制方法
    if (navigator.clipboard && window.isSecureContext) {
        // 使用现代浏览器的剪贴板API
        navigator.clipboard.writeText(value).then(() => {
            // 复制成功后的处理
            message.success('复制成功');
        }).catch((error) => {
            // 复制失败后的处理
            message.error('复制失败');
        })
    } else {
        // 对于不支持现代剪贴板API的浏览器的处理
        const input = document.createElement('textarea');
        input.value = value;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        // 成功复制的处理，这里和现代API分支共享相同的反馈逻辑
        message.success('复制成功');
    }
}

/**
 * 获取列表中某个字段的最大宽度值
 * @param {*} arr 列表数组
 * @param {*} key 要对比的键
 * @param {*} minWidth 最新宽度
 * @returns 
 */
export const GetArrSpanMaxWidth = (arr, key, minWidth = 100) => {
    if (arr.length < 1 || !key) {
        return minWidth;
    }
    let item = arr.reduce((max, cur) => {
        return max[key].length > cur[key].length ? max : cur;
    });
    let span = document.createElement('span');
    span.style.width = 'auto';
    span.innerHTML = item[key];
    document.body.appendChild(span);
    let maxWidth = span.offsetWidth;
    document.body.removeChild(span);
    return maxWidth + 30 > minWidth ? maxWidth + 30 : minWidth;
};


/**
 * 连接阿里云OSS实体
 * @param {*} token
 * @returns 
 */
export const AliyunOSSclient = (token) => {
    let params = { 'oss': 'GetObject' }
    return new OSS({
        region: token.oss_region,
        accessKeyId: token.Credentials.AccessKeyId,
        accessKeySecret: token.Credentials.AccessKeySecret,
        stsToken: token.Credentials.SecurityToken,
        authorizationV4: true,
        refreshSTSToken: async () => {
            // 向您搭建的STS服务获取临时访问凭证。
            const info = await fetch(CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params), {
                method: 'GET',
                headers: AddRequestHeaders(),
            });
            return {
                accessKeyId: info.dat.Credentials.accessKeyId,
                accessKeySecret: info.dat.Credentials.accessKeySecret,
                stsToken: info.dat.Credentials.stsToken,
            };
        },
        refreshSTSTokenInterval: 3500000, // 刷新临时访问凭证的时间间隔，单位为毫秒。
        internal: process.env.REACT_APP_OSS_INTERNAL === 'true' ? true : false,
        secure: true,
        bucket: token.bucket_name
    });
}

/**
 * 从阿里云删除
 * @param {*} file 
 * @returns 
 */
export const AliyunOSSDelete = (file) => {
    var params = {
        'acl': 'DeleteObject'
    }
    $.ajax({
        url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
        headers: AddRequestHeaders(),
        type: 'GET', success: function (data) {
            if (data.res === 0) {
                const token = data.dat;
                try {
                    AliyunOSSclient(token).delete(file.path);
                } catch (e) {
                    // console.log(e);
                }
            } else {
                message.error(data.msg, CNF.messageDuration);
            }
        }
    });
    return false
}

/**
 * 从阿里云下载
 * @param {*} file
 */
export const AliyunOSSDownload = (file) => {
    var params = {
        'oss': 'GetObject'
    }
    $.ajax({
        url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
        headers: AddRequestHeaders(),
        type: 'GET', success: function (data) {
            if (data.res === 0) {
                const token = data.dat;
                try {
                    let result = AliyunOSSclient(token).signatureUrl(file.path, {
                        expires: 3600,
                        response: {
                            'content-disposition': 'attachment; filename="' + file.name + '"'
                        }
                    });
                    return result;
                } catch (e) {
                    console.log(e);
                }
            } else {
                message.error(data.msg, 1);
            }
        }
    });
}


/*
 ************************************************
 ** 项目特有 **
 ************************************************
 */
const GenPresets = (presets) => {
    let data = Object.entries(presets);
    for (let i = 0; i < data.length; i++) {
        switch (data[i][0]) {
            case 'red':
                data[i][0] = '红色'
                break;
            case 'green':
                data[i][0] = '绿色'
                break;
            case 'blue':
                data[i][0] = '蓝色'
                break;
            case 'yellow':
                data[i][0] = '黄色'
                break;
            default:
            //
        }
    }
    return data.map(([label, colors]) => ({
        label,
        colors,
    }));
}

/**
 * 预设颜色
 * @returns 
 */
export const presets = GenPresets({
    red,
    green,
    blue,
    yellow,
    grey,
});